module.exports = __webpack_public_path__ + "img/avt3.4dd4d61a.19752d50.png";